/**
 * Display order for market groups on an event, ported from `Constants.MarketGroupsOrder`.
 * The empty string is a real group code in the feed — it holds markets the provider
 * left ungrouped — and its position is meaningful, so it is preserved.
 */
export const MARKET_GROUP_ORDER = [
  '1x2',
  'HA',
  'DC',
  'OU',
  'IOU',
  'OE',
  'EH',
  'AH',
  'SG',
  'HTFT',
  'BTS',
  'TNG',
  'DNB',
  'CS',
  'CSH',
  'COR',
  'SCORERS',
  '',
  'SPEC',
] as const;

/** Live adds "next goal" after the head-to-head group; otherwise identical. */
export const LIVE_MARKET_GROUP_ORDER = [
  '1x2',
  'HA',
  'NXG',
  'DC',
  'OU',
  'IOU',
  'OE',
  'EH',
  'AH',
  'SG',
  'HTFT',
  'BTS',
  'TNG',
  'DNB',
  'CS',
  'CSH',
  'COR',
  'SCORERS',
  '',
  'SPEC',
] as const;

export type MarketGroupCode =
  (typeof MARKET_GROUP_ORDER)[number] | (typeof LIVE_MARKET_GROUP_ORDER)[number];

function rankIn(order: readonly string[], code: string): number {
  const index = order.indexOf(code);
  // Unknown groups sort last rather than jumping to the front.
  return index === -1 ? order.length : index;
}

/**
 * Comparator for market group codes. Pass `live` so the "next goal" group lands in
 * the right place on in-play events.
 */
export function compareMarketGroups(a: string, b: string, live = false): number {
  const order = live ? LIVE_MARKET_GROUP_ORDER : MARKET_GROUP_ORDER;
  return rankIn(order, a) - rankIn(order, b);
}
